import React, {useEffect, useState} from "react";
import GLOBAL from "../../global";
import {generateQRCode} from "../../utils/Utils";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import playStoreImage from "../../assets/svg/Packages/play-store.svg";
import appStoreImage from "../../assets/svg/Packages/app-store.svg";

const getDefaultPackageFooter = (androidAppLink, iosAppLink, androidQR, iosQR) => `
        <!DOCTYPE html>
        <html lang="en">
        
        <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
        
          <style>
            /* Figma Styles of your File */
            :root {
              /* Colors */
              /* Fonts */
              --title-1-font-family: Outfit-Bold, sans-serif;
              --title-1-font-size: 28px;
              --title-1-line-height: 40px;
              --title-1-font-weight: 700;
              --title-1-font-style: normal;
              --text-font-family: Outfit-Regular, sans-serif;
              --text-font-size: 20px;
              --text-line-height: 30px;
              --text-font-weight: 400;
              --text-font-style: normal;
              --text-v-font-family: Outfit-SemiBold, sans-serif;
              --text-v-font-size: 20px;
              --text-v-line-height: 36px;
              --text-v-font-weight: 600;
              --text-v-font-style: normal;
              --italic-font-family: Roboto-LightItalic, sans-serif;
              --italic-font-size: 16px;
              --italic-line-height: 28px;
              --italic-font-weight: 300;
              --italic-font-style: italic;
              --title-b-font-family: Outfit-Bold, sans-serif;
              --title-b-font-size: 24px;
              --title-b-line-height: 40px;
              --title-b-font-weight: 700;
              --title-b-font-style: normal;
        
              /* Effects */
            }
        
            /* Figma Color Variables of your File */
            [data-variable-collection-mode="mode-1"] {
              /* mode-1 */
              --primary: #ca4818;
              --secondary: #1b3a57;
              --text: #212529;
              --primary-blue: #0077ff;
              --accent-orange: #ff7a00;
              --text-gray: #333333;
              --color-text: #2387bf;
            }
        
            .qr,
            .qr * {
              box-sizing: border-box;
            }
        
            .qr {
              display: flex;
              flex-direction: column;
              gap: 20px;
              align-items: flex-start;
              justify-content: flex-start;
              position: relative;
            }
        
            .title {
              color: #0075b6;
              text-align: left;
              font-family: var(--title-1-font-family, "Outfit-Bold", sans-serif);
              font-size: var(--title-1-font-size, 28px);
              line-height: var(--title-1-line-height, 40px);
              font-weight: var(--title-1-font-weight, 700);
              position: relative;
              align-self: stretch;
            }
        
            .subtitle {
              color: #3a3a3a;
              text-align: left;
              font-family: var(--title-b-font-family, "Outfit-Bold", sans-serif);
              font-size: var(--title-b-font-size, 24px);
              line-height: var(--title-b-line-height, 40px);
              font-weight: var(--title-b-font-weight, 700);
              position: relative;
              align-self: stretch;
            }
        
            .qr-codes-container {
              display: flex;
              flex-direction: row;
              gap: 29.15px;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;
              align-content: center;
              flex-shrink: 0;
              width: 359.21px;
              position: relative;
              
              @media (max-width: 767px) {
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
              }
            }
        
            .android-qr-container {
              background: #ffffff;
              border-radius: 4.4px;
              padding: 14.29px;
              display: flex;
              flex-direction: column;
              gap: 11px;
              align-items: center;
              justify-content: flex-start;
              flex-shrink: 0;
              position: relative;
            }
        
            .qrcode-1 {
              border-radius: 4.4px;
              display: flex;
              flex-direction: row;
              gap: 8.93px;
              align-items: center;
              justify-content: flex-start;
              align-self: stretch;
              flex-shrink: 0;
              position: relative;
              overflow: hidden;
            }
        
            .qrcode-2 {
              flex-shrink: 0;
              width: 133.99px;
              height: 133.99px;
              position: relative;
              object-fit: cover;
              aspect-ratio: 1;
            }
        
            .android-qr-text {
              color: #000000;
              text-align: center;
              font-family: "Roboto-Regular", sans-serif;
              font-size: 9.841422080993652px;
              font-weight: 400;
              position: relative;
              align-self: stretch;
            }
        
            .ios-qr-container {
              background: #ffffff;
              border-radius: 4.4px;
              padding: 14.29px;
              display: flex;
              flex-direction: column;
              gap: 11px;
              align-items: center;
              justify-content: flex-start;
              flex-shrink: 0;
              position: relative;
            }
        
            .group {
              flex-shrink: 0;
              width: 133.99px;
              height: 133.99px;
              position: static;
            }
        
            .qrcode-1-2 {
              width: 100%;
              height: 100%;
              position: absolute;
              right: 0%;
              left: 0%;
              bottom: 0%;
              top: 0%;
              object-fit: cover;
              aspect-ratio: 1;
            }
        
            .ios-qr-text {
              color: #000000;
              text-align: center;
              font-family: "Roboto-Regular", sans-serif;
              font-size: 9.841422080993652px;
              font-weight: 400;
              position: relative;
              align-self: stretch;
            }
        
            .download-text {
              color: #565656;
              text-align: left;
              font-family: var(--title-b-font-family, "Outfit-Bold", sans-serif);
              font-size: var(--title-b-font-size, 24px);
              line-height: var(--title-b-line-height, 40px);
              font-weight: var(--title-b-font-weight, 700);
              position: relative;
              align-self: stretch;
            }
        
            .frame-427320490 {
              display: flex;
              flex-direction: row;
              gap: 15.96px;
              align-items: flex-start;
              justify-content: flex-start;
              flex-wrap: wrap;
              align-content: flex-start;
              align-self: stretch;
              flex-shrink: 0;
              position: relative;
              
              @media (max-width: 767px) {
                  align-items: center;
                  justify-content: center;
              }
            }
        
            .playstore {
              flex-shrink: 0;
              width: 161.34px;
              height: 52.63px;
              position: relative;
              overflow: visible;
            }
        
            .app-store {
              flex-shrink: 0;
              width: 162.69px;
              height: 54.39px;
              position: relative;
              overflow: visible;
            }
        
            a,
            button,
            input,
            select,
            h1,
            h2,
            h3,
            h4,
            h5,
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
              border: none;
              text-decoration: none;
              background: none;
        
              -webkit-font-smoothing: antialiased;
            }
        
            menu,
            ol,
            ul {
              list-style-type: none;
              margin: 0;
              padding: 0;
            }
          </style>
          <title>Document</title>
        </head>
        
        <body>
            <div class="qr">
                <div class="title">GET OUR APP</div>
                <div class="subtitle">Scan QR to get The App Link</div>
                <div class="qr-codes-container">
                    <div class="android-qr-container">
                        <div class="qrcode-1">
                            <img class="qrcode-2" src="${androidQR}" alt="android QR code"/>
                        </div>
                        <div class="android-qr-text">Scan for android</div>
                    </div>
                    <div class="ios-qr-container">
                        <div class="qrcode-1" style="
                                background: url(qrcode-11.png) center;
                                background-size: cover;
                                background-repeat: no-repeat;
                              ">
                            <div class="group">
                                <img class="qrcode-2" src="${iosQR}" alt="iOS QR code"/>
                            </div>
                        </div>
                        <div class="ios-qr-text">Scan for IOS</div>
                    </div>
                </div>
                <div class="download-text">Download App From</div>
                <div class="frame-427320490">
                    <a href="${androidAppLink}" target="_blank">
                        <img class="playstore" src="${playStoreImage}" alt="play store image"/>
                    </a>
                    <a href="${iosAppLink}" target="_blank">
                        <img class="app-store" src="${appStoreImage}" alt="app store image"/>
                    </a>
                </div>
            </div>
        </body>
    `;

const PackageFooter = () => {
    const [packageFooter, setPackageFooter] = useState("");

    const { androidAppLink, iosApplink: iosAppLink } = useTenantFeatures();

    useEffect(() => {
        const loadQRCodeAndSetFooter = async () => {
            try {
                const [androidQR, iosQR] = await Promise.all([
                    generateQRCode(androidAppLink),
                    generateQRCode(iosAppLink),
                ]);

                const footerHTML = getDefaultPackageFooter(androidAppLink, iosAppLink, androidQR, iosQR);
                setPackageFooter(footerHTML);
            } catch (error) {
                console.error("QR Code generation failed", error);
                setPackageFooter("<p>Unable to load QR codes.</p>");
            }
        };

        loadQRCodeAndSetFooter();
    }, [androidAppLink, iosAppLink]);

    return (
        <div
            // className="padding-1-5rem"
            className="mr-2"
            dangerouslySetInnerHTML={{__html: packageFooter}}
        />
    );
};

export default PackageFooter;